import dayjs from 'dayjs';
import isSameOrAfter from 'dayjs/plugin/isSameOrAfter';
dayjs.extend(isSameOrAfter);

import { NonFaceToFaceBookingSchedulesInfo } from '@/models/diagnosis';

export const filteredF2FDaySchedules = (
  days: NonFaceToFaceBookingSchedulesInfo['daySchedules'],
  dateToSelect?: string | null
): NonFaceToFaceBookingSchedulesInfo['daySchedules'] => {
  if (!dateToSelect) return days;

  const base = dayjs(dateToSelect);
  const filtered = days.filter((d) => dayjs(d.targetDate).isSameOrAfter(base, 'day'));
  return [...filtered];
};
